import { render, staticRenderFns } from "./index.vue?vue&type=template&id=977464b0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=977464b0&prod&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=977464b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977464b0",
  null
  
)

export default component.exports